import { Component, EventEmitter, Output } from '@angular/core';

export interface LoginPayload {
  email: string;
  password: string;
  onError?: (message: string) => void;
}

@Component({
  selector: 'app-login-card',
  standalone: false,
  templateUrl: './login-card.component.html',
  styleUrls: ['./login-card.component.css'],
})
export class LoginCardComponent {
  @Output() loginSubmit    = new EventEmitter<LoginPayload>();
  @Output() forgotPassword = new EventEmitter<void>();   // ← new

  email         = '';
  password      = '';
  showPassword  = false;
  loading       = false;
  errorMessage  = '';

  get isFormValid(): boolean {
    return this.email.trim().length > 0 && this.password.length >= 6;
  }

  onSubmit(): void {
    if (!this.isFormValid || this.loading) return;
    this.loading      = true;
    this.errorMessage = '';
    this.loginSubmit.emit({
      email:    this.email,
      password: this.password,
      onError:  (msg: string) => { this.errorMessage = msg; this.loading = false; },
    });
  }

  onForgotPassword(): void {
    this.forgotPassword.emit();
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }
}